import { CancelToken } from '@/app/shared/command-queue'
import { err, ok } from '@xlearn/common'
import { waitToLoad, WaitToLoadError } from '@/app/shared/utils'
import { ExamStoreModule, FindExamError } from '@/app/exam/state'

export type LoadExamError = WaitToLoadError | FindExamError

export class LoadExamJob {

  constructor(private examStore: ExamStoreModule) { }

  async execute(examId: string, cancel: CancelToken) {
    const result = await waitToLoad(() => this.examStore.loadingPhase === 'loaded', cancel)
    if (!result.success) {
      return err(result.error as LoadExamError)
    }

    const findResult = this.examStore.findExam(examId)
    if (!findResult.success) {
      return findResult
    }

    const exam = findResult.value
    return ok(exam)
  }
}
